// React
import React from 'react';
import { Card, Col, Row } from 'reactstrap';

// Injections
import { DropdownDatatable } from '../../../../components/dropdownDatatable';
import { FloatButton, PageWrapper } from '../../containers/componentsInjection';

export const CategoriesPlansPage = ({
  categoryPlans,
  columns,
  handleDelete,
  history,
}) => {
  return (
    <PageWrapper title={'Categorias de Planos'}>
      <Row>
        <Col xs={12}>
          <Card>
            <DropdownDatatable
              title="Categorias de planos"
              titleButton="Nova categoria de plano"
              data={categoryPlans ? categoryPlans : []}
              columns={columns}
              pagination
              persistTableHead
              perPage={10}
              actions={[
                {
                  id: 1,
                  name: 'edit',
                  label: 'Editar',
                  onPress: (cellProps) =>
                    history.push(
                      `/configuracoes/tabelas/categorias-planos/editar/${cellProps.id}`
                    ),
                  icon: 'la-pen',
                  classNameColorIcon: 'primary',
                },
              ]}
              isSearchRemote={false}
              handleDelete={(cellProps) => handleDelete(cellProps)}
            />
          </Card>
        </Col>
      </Row>
      <FloatButton
        handleButton={() =>
          history.push('/configuracoes/tabelas/categorias-planos/novo')
        }
      />
    </PageWrapper>
  );
};
